import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { serializeFilters } from '@user/components/Filters'
import { OpportunityFilterSet } from '../filters'
import { IOpportunity } from '../typings'
import { setOpportunityFilters } from '../slice'

export const useSaveOpportunityFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const oppPrefs = useMemo(() => prefs.find((p) => p.type === 'opp'), [prefs])

  return useCallback(
    (model: OpportunityFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: oppPrefs?.id,
          type: 'opp',
          name: 'opp filters',
          filter: serializeFilters<IOpportunity, OpportunityFilterSet>(model),
        }),
      )
      dispatch(setOpportunityFilters(model))
    },
    [dispatch, oppPrefs?.id],
  )
}
